module.exports = {
    "source_code": "HLXEMS",
    "site_id": "discover.logan.edu",
    "title": "Logan University",
    "tfn": "",
    "url": "https://discover.logan.edu",
    "gtm_code": "GTM-TSBQQWF",
}